module.exports = __webpack_public_path__ + "img/domestic-transport-1.63065eac.png";